import http from '../utils/http';

const homeApi = {
    /**
     * 近7天终端在线离线数量
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#247
     */
    sevenDeviceLineInfo() {
        return http.post('/reportForms/sevenDeviceLineInfo')
    },

    /**
     * 近7天节目发布信息数
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#239
     */
    sevenProgramInfo() {
        return http.post('/reportForms/sevenProgramInfo')
    },

    /**
     *  近7天单个素材平均每天曝光次数
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#240
     */
    fileAverageExposureNum() {
        return http.post('/reportForms/fileAverageExposureNum')
    },

    /**
     * 近7天单个终端下载量
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#242
     */
    getProgramDownloadNum() {
        return http.post('/reportForms/getProgramDownloadNum')
    },

    /**
     * 今日终端信息数据统计
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#234
     */
    getToDayDeviceInfo() {
        return http.post('/reportForms/getToDayDeviceInfo')
    },

    /**
     * 今日节目信息统计数据
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#235
     */
    getToDayProgramInfo() {
        return http.post('/reportForms/getToDayProgramInfo')
    },

    /**
     * 今日异常统计
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#236
     */
    getStatistics() {
        return http.post('/reportForms/getStatistics')
    },

    /**
     * 7日未上线终端详情
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#237
     */
    sevenNotLoginDeviceInfo(param) {
        return http.post('/reportForms/sevenNotLoginDeviceInfo', param)
    },

    /**
     * 7日未上线终端详情导出
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#237
     */
    exportSevenNotLoginDeviceInfo(options = {}, config = {}) {
        return http.get('/reportForms/exportSevenNotLoginDeviceInfo', options, {
            ...config
        });
    },


    /**
     * 增播减播失败详情
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#238
     */
    programAddSubFailedInfo(param) {
        return http.post('/reportForms/programAddSubFailedInfo', param)
    },

    /**
     * 今日发布节目/素材
     * http://rap.i.xinchao.com/workspace/myWorkspace.do?projectId=10#284
     */
    getNewToDayProgramInfo(param) {
        return http.post('/reportForms/getNewToDayProgramInfo', param)
    },

    /**
     * 今日解绑的终端数量
     * http://rap.i.xinchao.com/workspace/myWorkspace.do?projectId=10#274
     */
    todayUntieDeviceNum(param) {
        return http.post('/reportForms/todayUntieDeviceNum', param)
    },

    /**
     * 新增终端数详情
     * http://rap.i.xinchao.com/workspace/myWorkspace.do?projectId=10#274
     */

    exportNewAdd(options = {}, config = {}){
        return http.get('/reportForms/exportTodayNewDeviceInfo', options, {
            ...config
        });
    },

    /**
     * 按节目数量统计终端数
     * http://rap.i.xinchao.com/workspace/myWorkspace.do?projectId=10#274
     */

    getProgramDeviceNum(param){
        return http.post('/reportForms/deviceProgramInfo',param)
    },

    /**
     * 按节目数量统计终端数的详情列表
     * http://rap.i.xinchao.com/workspace/myWorkspace.do?projectId=10#274
     */

     getProgramDeviceDetail(param){
         return http.post('/reportForms/deviceProgramDetail',param)
     },

     /**
     * 按节目数量统计终端数详情导出
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#237
     */
    exportProgramDeviceDetail(options = {}, config = {}) {
        return http.get('/reportForms/deviceProgramExcel', options, {
            ...config
        });
    }
}

export default homeApi;
